import { fg } from '@atlassian/jira-feature-gating';
import { fieldSchemeSelfConversionEntryPoint } from '@jira/admin-pages__field-scheme-self-conversion/src/fieldSchemeSelfConversionEntryPoint.entrypoint.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsFieldSchemeSelfConversionRoute } from '@jira/router-routes__field-scheme-self-conversion-routes/src/globalSettingsFieldSchemeSelfConversionRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

const fieldSchemeSelfConversionPageEntryPoint = createPageEntryPoint({
	main: fieldSchemeSelfConversionEntryPoint,
});

export const globalSettingsFieldSchemeSelfConversionRouteEntry: Route = createEntry(
	globalSettingsFieldSchemeSelfConversionRoute,

	() => ({
		layout: globalSettingsLayout,

		// No sidebar nav entry — this page is only accessible via a direct URL.
		navigation: {},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		// Swap to not-found when the feature gate is off
		entryPoint: () =>
			fg('nfa-c2c-self-conversion-fe')
				? fieldSchemeSelfConversionPageEntryPoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
